import { loadMessages, locale } from "devextreme/localization";
import { nanoid } from "nanoid";
import {
  call,
  safe,
  select,
  sleep,
  takeEvery,
  takeLeading,
  updateStore,
} from "starfx";

import roMessages from "@app/locales/devex.ro.json";
import { runBootSequence } from "@app/statefx/xThunks/ds";

import { isErr, keyValFrom } from "../helpers";
import { pass } from "../helpers/pass";
import { schema } from "../schema";
import { TWhoami } from "../schema/app.def";
import { selectorWorkerGxDBName } from "../selectors/app.sel";
//
import { xApi, xThunk } from "../xapis";
import { releaseLock } from "./prc-lock";

import type { Next, ThunkCtx } from "starfx";
import type { TApp } from "@app/statefx/schema/app.def";
const db = schema;

function* lastButNotLeast() {
  yield* call(() => loadMessages(roMessages));
  yield* call(() => locale("ro"));
}

export const getAppEnv = xThunk.create(
  `thunks/getAppEnv`,
  { supervisor: takeLeading },
  function* (ctx: ThunkCtx, next: Next) {
    const delphi = yield* call(() => window?.delphiRequire("Jurnal_Quick"));
    console.log("delphi", delphi);
    if (isErr(delphi)) {
      yield* updateStore(
        db.app.update({ key: "thisPath", value: "A:\\mockdir\\" })
      );
      return;
    }
    const thisPath = yield* safe(() => delphi.util.getCrtPath());
    const thisPathValue = pass(thisPath);
    yield* updateStore(
      db.app.update({ key: "thisPath", value: thisPathValue })
    );
    yield* next();
    yield* call(lastButNotLeast);
  }
);

export const appReloadChromium = xThunk.create(
  `thunks/processReloadChromium`,
  { supervisor: takeLeading },
  function* (ctx: ThunkCtx, next: Next) {
    if (process.env.REACT_APP_MODE === "REACT") {
      window.location.reload();
    }
    if (process.env.REACT_APP_MODE === "DELPHI") {
      const delphi = yield* call(() => window?.delphiRequire("Jurnal_Quick"));
      yield* safe(() =>
        delphi.app.assetStore(
          JSON.stringify({
            type: "COMMAND",
            payload: { command: "chromium.reload" },
          })
        )
      );
    }
    yield* next();
  }
);

export const sfxUpdateWhoami = xThunk.create<TWhoami>(
  "/sfx/updateWhoami",
  { supervisor: takeLeading },
  function* (ctx, next) {
    //we only edit this values
    // const { Nume, Prenume } = ctx.payload;
    // on the second thought...
    // we don't need to update the whoami from inside Jurnal..
    // we do this from MOA, in the larger, parent database.
    // ...
    yield* updateStore(db.whoami.set(ctx.payload));
    yield* next();
  }
);
export const updateAppData = xThunk.create<Partial<TApp>>(
  "/sfx/setAppData",
  { supervisor: takeEvery },
  function* (ctx: ThunkCtx, next: Next) {
    const [k, v] = keyValFrom(ctx.payload);
    yield* schema.update(
      db.app.update({
        key: k,
        value: v,
      })
    );
    yield* next();
  }
);

export const clearLock = xThunk.create(
  "/sfx/clearLock",
  { supervisor: takeLeading },
  function* (ctx: ThunkCtx, next: Next) {
    yield* updateStore(db.lock.set(""));
    yield* next();
  }
);

export const reloadApp = xThunk.create(
  "/sfx/reloadApp",
  { supervisor: takeLeading },
  function* (ctx: ThunkCtx, next: Next) {
    const indexDbName = yield* select(selectorWorkerGxDBName);
    // kill gx worker.
    // yield* call(() => terminateWorker());
    // yield* sleep(300);
    // yield* call(() => initGxWorker(indexDbName));
    // the persistor worker remains.
    yield* sleep(300);
    const newRenderKey = nanoid();
    yield* updateStore([
      db.uiRenderKey.set(newRenderKey),
      db.loaderPopup.set(true),
    ]);
    yield* releaseLock();
    yield* sleep(300);
    yield* call(() => runBootSequence.run());
    yield* next();
  }
);

export const appNewInsiderGate = xThunk.create(
  "/sfx/appNewInsiderGate",
  { supervisor: takeEvery },
  function* (ctx: ThunkCtx, next: Next) {
    const randomKey = nanoid();
    yield* updateStore(db.uiRenderKey.set(randomKey));
    yield* next();
  }
);
